export class Resource {
    id: string | any
    sort: number | any
}
export class NameId extends Resource {
    name: string | null | undefined
}